import { Col, Divider, Row, Tag, Tooltip, Typography } from 'antd'
import React, { useState } from 'react'
import { PlusOutlined } from '@ant-design/icons'
import { EditIcon, NoProjectsIcon } from '../../../assets/icons'
import ProjectForm from './project-form'
import NoIndividualContent from '../../profile/tabSection/noIndividualContent'
import dayjs from 'dayjs'
import { useSelector } from 'react-redux'

const ProjectTab = ({ currantData,
    activeTab,
    candidateId,
    showForm,
    setShowForm, status }) => {
    const [editData, setEditData] = useState(null)
    const convertToUserStatus = 'convertToUser'

    const { Title, Text } = Typography
    const { isLoading } = useSelector((state) => state.candidateSlice)

    return (
        <div>
            <div style={{ marginTop: '15px' }}>

                {!showForm && !isLoading && (

                    <>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <Title level={4}>Project</Title>
                            {
                                status !==
                                convertToUserStatus && <Tooltip title="Add Project">
                                    <button
                                        style={{
                                            width: '26px',
                                            height: '26px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            marginLeft: '10px',
                                            borderRadius: '50%',
                                            border: 'none',
                                        }}
                                        onClick={() => { setShowForm(true); setEditData(null) }}
                                    >
                                        <PlusOutlined
                                            style={{ fontSize: '15px' }}
                                        />
                                    </button>
                                </Tooltip>}

                        </div>
                        {currantData?.projects?.length === 0 ?
                            <NoIndividualContent
                                content={{
                                    key: 'projects',
                                    title: 'Projects',
                                    icon: <NoProjectsIcon />,
                                }}
                            /> : <div style={{ marginTop: '15px' }}>
                                {
                                    currantData?.projects?.map((e) => {
                                        return (
                                            <Row gutter={25} >
                                                <Col
                                                    xs={4}
                                                    sm={4}
                                                    md={4}
                                                    lg={4}
                                                    xl={4}
                                                    style={{
                                                        border: '1px solid #f0f0f0 ',
                                                        padding: '10px',
                                                        height: '100%',
                                                        borderRadius: '8px',
                                                        display: 'flex',
                                                        justifyContent: 'center'
                                                    }}
                                                >
                                                    <div className="educationSvgLogo" />
                                                </Col>
                                                <Col
                                                    xs={20}
                                                    sm={20}
                                                    md={20}
                                                    lg={20}
                                                    xl={20}
                                                >
                                                    <div>
                                                        <div
                                                            style={{
                                                                display: 'flex',
                                                                alignItems:
                                                                    'center',
                                                            }}
                                                        >
                                                            <Title level={5}>
                                                                {e.name}
                                                            </Title>
                                                            {status !== convertToUserStatus && <Tooltip title="Edit Project">
                                                                <button
                                                                    style={{
                                                                        width: '26px',
                                                                        height: '26px',
                                                                        display:
                                                                            'flex',
                                                                        alignItems:
                                                                            'center',
                                                                        justifyContent:
                                                                            'center',
                                                                        marginLeft:
                                                                            '5px',
                                                                        borderRadius:
                                                                            '50%',
                                                                        border: 'none',
                                                                        backgroundColor:
                                                                            'transparent',
                                                                    }}
                                                                    onClick={() => {
                                                                        setShowForm(
                                                                            true
                                                                        )
                                                                        setEditData(
                                                                            e
                                                                        )
                                                                    }}
                                                                >
                                                                    <EditIcon />
                                                                    {/* <PlusOutlined style={{ fontSize: '15px' }} /> */}
                                                                </button>
                                                            </Tooltip>}

                                                        </div>
                                                        <Text style={{ fontSize: "14px" }}>{e.description || '-'}</Text>
                                                    </div>

                                                    <div
                                                        style={{ marginTop: '5px' }}
                                                    >
                                                        <Text
                                                            style={{
                                                                color: '#b9b9b9',
                                                                fontSize: '16px',
                                                            }}
                                                        >
                                                            <Text style={{ color: "#b9b9b9", fontSize: "16px" }}>{dayjs(e?.startDate).format('DD MMM YY')}</Text>

                                                        </Text>
                                                        <Text
                                                            style={{
                                                                fontSize: '14px',
                                                                marginRight: '10px',
                                                                marginLeft: '10px',
                                                            }}
                                                        >
                                                            -
                                                        </Text>
                                                        <Text
                                                            style={{
                                                                color: '#b9b9b9',
                                                                fontSize: '16px',
                                                            }}
                                                        >
                                                            {!e.currentWorking && <Text style={{ color: "#b9b9b9", fontSize: "16px" }}>{dayjs(e?.endDate).format('DD MMM YY')}</Text>}
                                                            {e.currentWorking
                                                                && <Text style={{ color: "#b9b9b9", fontSize: "16px" }}>Present
                                                                </Text>}
                                                        </Text>
                                                    </div>
                                                    <div>
                                                        {e?.technologies
                                                            ?.length > 0 && (
                                                                <>
                                                                    <div
                                                                        style={{
                                                                            marginTop:
                                                                                '15px',
                                                                        }}
                                                                    >
                                                                        <div>
                                                                            <Text
                                                                                style={{
                                                                                    fontSize:
                                                                                        '18px',
                                                                                }}
                                                                            >
                                                                                Technologies

                                                                            </Text>
                                                                        </div>
                                                                    </div>
                                                                    <Row gutter={10}>
                                                                        {e?.technologies?.map(
                                                                            (
                                                                                data,
                                                                                index
                                                                            ) => {
                                                                                return (
                                                                                    <Tag
                                                                                        key={
                                                                                            index
                                                                                        }
                                                                                        bordered={
                                                                                            false
                                                                                        }
                                                                                        color="processing"
                                                                                        style={{
                                                                                            marginTop:
                                                                                                '10px',
                                                                                            cursor: "auto"
                                                                                        }}
                                                                                    >
                                                                                        {
                                                                                            data
                                                                                        }
                                                                                    </Tag>
                                                                                )
                                                                            }
                                                                        )}
                                                                    </Row>
                                                                </>
                                                            )}
                                                    </div>
                                                </Col>
                                                <Divider />
                                            </Row>
                                        )
                                    })
                                }

                            </div>
                        }

                    </>
                )}

                {showForm && (
                    <ProjectForm
                        onCancel={setShowForm}
                        candidateId={candidateId}
                        currantData={editData}
                        activeTab={activeTab}
                        preProjectData={currantData}
                    />
                )}
            </div>
        </div>
    )
}

export default ProjectTab
